import { ReactComponent as ImportIcon } from 'images/icons/menu/Document.svg';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const ImportStudentListButton = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const iss = useStores().inviteStudentsStore;

  return (
    <button
      onClick={() => {
        location.pathname !== '/Organization/Students' && navigate('/Organization/Students');
        iss.isImportModalOpen = true;
      }}
      className='styled-button primary add-button invite-students-button'
    >
      <ImportIcon />
      <span>{t('ImportStudentList', { ns: 'studentsPage' })}</span>
    </button>
  );
});

export default ImportStudentListButton;
